import React from 'react';
import { Route, Redirect } from 'react-router-dom';


class PrivateRoute extends React.Component {


  render() {
    if (!this.props.loggedIn) {
      return <Redirect to={{ pathname: '/login', state: { from: this.props.location } }} />
    }
    return <Route {...this.props} />
  }
}


export default PrivateRoute;